import { HttpErrorResponse } from "@angular/common/http";
import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { FilterFormModal } from "src/app/models/form-group.model";
import { ApiService } from "src/app/services/api.service";

enum TabIndex {
  pending,
  approved,
  declined,
}
@Component({
  selector: "fury-technician-listing",
  templateUrl: "./technician-listing.component.html",
  styleUrls: ["./technician-listing.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class TechnicianListingComponent implements OnInit {
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  public tabIndex = TabIndex;
  tabStatus = {
    Pending: "pending",
    Approved: "approved",
    Declined: "declined",
  };
  selectedTabIndex = this.tabIndex.pending;

  columns = [
    { name: "First Name", property: "firstName", visible: true },
    { name: "Last Name", property: "lastName", visible: true },
    { name: "Company Name", property: "companyName", visible: true },
    {
      name: "Work Order Email",
      property: "workOrderEmailAddress",
      visible: true,
    },
    {
      name: "Work Order Phone No",
      property: "workOrderPhoneNumber",
      visible: true,
    },
    { name: "Rating", property: "rating", visible: true },
    { name: "Actions", property: "actions", visible: true },
  ];

  serchByValue: any[] = [
    { title: "First Name", value: "firstName" },
    { title: "Last Name", value: "lastName" },
    { title: "Email Address", value: "workOrderEmailAddress" },
    { title: "Phone Number", value: "workOrderPhoneNumber" },
  ];
  searchTypeValue: any[] = [
    { title: "Contains", value: "contains" },
    { title: "Starts With", value: "startsWith" },
    { title: "Not Contains", value: "notContains" },
    { title: "End With", value: "endWith" },
    { title: "Equals", value: "equals" },
    { title: "Not Equals", value: "notEquals" },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  selectedStatus = this.tabStatus.Pending;
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  isActive: any = null;
  ngUnsubscribe = new Subject<void>();
  searchForm = new FormGroup({
    companyName: new FormControl(""),
    firstName: new FormControl(""),
    lastName: new FormControl(""),
    workOrderEmailAddress: new FormControl(""),
    workOrderPhoneNumber: new FormControl(""),
  });
  searchValue: any = {};
  isLoading = false;
  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.filterValue = "Technicians";
    this.router.onSameUrlNavigation = "reload";
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.pageIndex = res.page ? res.page - 1 : 0;
        this.pageSize = res.size ? (res.size === "all" ? 9999 : res.size) : 30;
        this.selectedStatus =
          res.status?.length > 0 ? res.status : this.tabStatus.Pending;
        this.selectedTabIndex = this.tabIndex[
          res.status
        ] as unknown as TabIndex;
        this.getAllTechnician();
      });
  }

  getAllTechnician() {
    this.isLoading = true;
    this.apiService
      .get(
        `${endpoints.partners.serviceProvider.getAllTechnician}?status=${
          this.selectedStatus
        }&page=${Number(this.pageIndex) + 1}&size=${this.pageSize}&firstName=${
          this.searchValue?.firstName || ""
        }&lastName=${this.searchValue?.lastName || ""}&workOrderEmailAddress=${
          this.searchValue?.workOrderEmailAddress || ""
        }&workOrderPhoneNumber=${
          this.searchValue?.workOrderPhoneNumber || ""
        }&companyName=${this.searchValue?.companyName || ""}${
          this.isActive ? "&isActive=" + this.isActive : ""
        }`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res.body) {
          this.isLoading = false;
          if (res.body.technicians.data) {
            this.itemList = res.body.technicians.data;
            this.totalCount = res.body.technicians.total;
            this.dataSource = new MatTableDataSource(this.itemList);
            this.cdr.detectChanges();
          } else {
            this.itemList = [];
            this.totalCount = 0;
            this.dataSource = new MatTableDataSource(this.itemList);
          }
        }
      },
    (err: HttpErrorResponse)=>{
      this.isLoading = false;
      this.apiService.alert(err.message, ErrorType.Error);
    });
  }

  tabChangeHandle(event: MatTabChangeEvent) {
    this.pageIndex = 0;
    this.selectedStatus = this.tabStatus[event.tab?.textLabel];
    this.selectedTabIndex = this.tabIndex[this.selectedStatus];
    this.searchForm.setValue(this.searchForm.value as any);
    this.searchForm.updateValueAndValidity();
    this.getAllTechnician();
  }

  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/partners/service-providers/technician?page=${
        this.pageIndex + 1
      }&status=${this.selectedStatus}${
        this.pageSize
          ? "&size=" + (this.pageSize === 9999 ? "all" : this.pageSize)
          : ""
      }`
    );
  }

  handleFetchTechnician(event) {
    if (event) {
      this.getAllTechnician();
    }
  }
  handleSearch(event: any) {
    this.searchValue = event;
    this.getAllTechnician();
  }
}
